import React from "react";
export default function Textarea(props: React.TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return (
    <textarea
      {...props}
      className={[
        "w-full rounded-[8px] border",
        "border-[#D6DADF] bg-white px-3 py-2 text-sm outline-none",
        "focus:border-[#B5BBC2] min-h-[84px]",
        props.className || ""
      ].join(" ")}
    />
  );
}
